import {createContext, type ReactNode, useContext} from "react";

import type {TypesenseSearchRecorder} from "../typesenseSearchTelemetry";

const ignoreTypesenseSearch: TypesenseSearchRecorder = () => undefined;
const TypesenseSearchTelemetryContext = createContext<TypesenseSearchRecorder>(ignoreTypesenseSearch);

export function TypesenseSearchTelemetryProvider({
    children,
    recordSearch,
}: {
    children: ReactNode;
    recordSearch: TypesenseSearchRecorder;
}) {
    return (
        <TypesenseSearchTelemetryContext.Provider value={recordSearch}>
            {children}
        </TypesenseSearchTelemetryContext.Provider>
    );
}

export function useTypesenseSearchTelemetry(): TypesenseSearchRecorder {
    return useContext(TypesenseSearchTelemetryContext);
}
